import {useSessionStorage} from '@github-ui/use-safe-storage/session-storage'
import {useCallback} from 'react'

export const OPEN_STATE_KEY = 'copilot-chat-app-embedded:v1:open'

export function usePersistedChatOpenState(): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useSessionStorage<boolean>(OPEN_STATE_KEY, false)
  const setFlushed = useCallback((next: boolean) => setOpen(next, {flush: true}), [setOpen])
  return [open, setFlushed]
}

export function readPersistedChatOpenState(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return JSON.parse(window.sessionStorage.getItem(OPEN_STATE_KEY) ?? 'false') === true
  } catch {
    return false
  }
}
